module.exports = __webpack_public_path__ + "assets/icon-arrow-right-component.7d04bfee.svg";